import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { decryptToken } from "./utils/getToken";

const UserRegisterEditModal = ({ isOpen, setIsOpen, fetchData, dataEdit, categories }) => {
    const [data, setData] = useState({
        id: "",
        full_name: "",
        email: "",
        website_link: "",
        category: "",
    });
    const [profileFile, setProfileFile] = useState(null);
    const [existingProfilePic, setExistingProfilePic] = useState("");

    const urlmain = API_BASE_URL;
    const [loading, setLoading] = useState(false);
    const token = decryptToken("accessToken") || "";

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleProfileChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setProfileFile(file);
        }
    };

    const resetForm = () => {
        setData({
            id: "",
            full_name: "",
            email: "",
            website_link: "",
            category: "",
        });
        setProfileFile(null);
        setExistingProfilePic("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const form = new FormData();
            form.append("full_name", data.full_name);
            form.append("email", data.email);
            form.append("category", data.category);
            if (data.website_link) {
                form.append("website_link", data.website_link);
            }
            if (profileFile) {
                form.append("profilePic", profileFile);
            }

            const response = await fetch(`${urlmain}/register/updatenew/${data.id}`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,
            });
            const res = await response.json();
            if (response.ok) {
                toast.success(res.message);
                setIsOpen(false);
                fetchData();
                resetForm();
            } else {
                toast.error(res.message || "Failed to update admin");
            }
        } catch (error) {
            toast.error(error?.message || "Failed to update admin");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (dataEdit && dataEdit.id) {
            setData({
                id: dataEdit.id,
                full_name: dataEdit.full_name || "",
                email: dataEdit.email || "",
                category: dataEdit.category || "",
                website_link: dataEdit.website_link || "",
            });
            setExistingProfilePic(dataEdit.profilePic || "");
            setProfileFile(null);
        }
    }, [dataEdit]);

    if (!isOpen) return null;

    const previewSrc = profileFile
        ? URL.createObjectURL(profileFile)
        : existingProfilePic
            ? `${urlmain}/logo/${String(existingProfilePic).replace(/\\/g, "/")}`
            : null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="oms-modal-title">Edit Admin</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="full_name" className="oms-form-label">
                            Full Name
                        </label>
                        <input
                            type="text"
                            name="full_name"
                            id="full_name"
                            value={data.full_name}
                            onChange={handleInputChange}
                            placeholder="Enter Full Name"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="category">Category</label>
                        <select
                            id="category"
                            name="category"
                            value={data.category}
                            onChange={handleInputChange}
                        >
                            <option value="">Select Category</option>
                            {categories.map((cat) => (
                                <option key={cat.id} value={cat.category_name}>
                                    {cat.category_name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="email" className="oms-form-label">
                            Email
                        </label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            onChange={handleInputChange}
                            value={data.email}
                            placeholder="Enter Email"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="profilePic" className="oms-form-label">
                            Profile Picture
                        </label>
                        <input
                            type="file"
                            name="profilePic"
                            id="profilePic"
                            accept="image/*"
                            onChange={handleProfileChange}
                        />
                        {previewSrc && (
                            <img
                                src={previewSrc}
                                alt="Profile preview"
                                style={{
                                    display: "block",
                                    marginTop: "10px",
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                }}
                                onError={(e) => {
                                    e.currentTarget.style.display = "none";
                                }}
                            />
                        )}
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="website_link" className="oms-form-label">
                            Website Url
                        </label>
                        <input
                            type="text"
                            name="website_link"
                            id="website_link"
                            onChange={handleInputChange}
                            value={data.website_link}
                            placeholder="Enter website url"
                        />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {loading ? (
                            <button type="button" disabled={loading}>
                                Loading...
                            </button>
                        ) : (
                            <button type="submit">Submit</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserRegisterEditModal;
